module.exports = __webpack_public_path__ + "static/media/acerta-pin.076879cb.svg";